import GastroAnoRettoColonscopiaEdit from "./components/GastroAnoRettoColonscopiaEdit.vue"
import GastroAnoRettoColonscopiaView from "./components/GastroAnoRettoColonscopiaView.vue"
import GastroAnoRettoColonscopiaList from "./components/GastroAnoRettoColonscopiaList.vue"

export default{
    GastroAnoRettoColonscopiaEdit,
    GastroAnoRettoColonscopiaView,
    GastroAnoRettoColonscopiaList
}